<script>
export const group = 'Full'
</script>

<script setup>
import CharacterJumpFromTheRight from '../kijk_live_qmusic_nl_default/text_animations/CharacterJumpFromTheRight.vue'

const props = defineProps({
  item: Object,
})

const timelinePosition = ref(null)

const chart = computed(() => props.item?.enrichment?.chart)
const currentPosition = computed(() => props.item?.enrichment?.chart?.currentPosition)
const positionText = computed(() => (currentPosition.value == null ? '' : String(currentPosition.value)))
const fallbackProgramTitle = computed(() => props.item?.enrichment?.program?.title)
const positionSizeClass = computed(() => {
  if (positionText.value.length >= 3) return 'text-[clamp(120px,min(48vw,92vh),1200px)]'
  if (positionText.value.length === 2) return 'text-[clamp(120px,min(62vw,95vh),1200px)]'
  return 'text-[clamp(120px,min(70vw,95vh),1200px)]'
})
</script>

<template>
  <div v-if="chart && currentPosition" class="position-container flex justify-center h-full w-full items-center py-24 flex-col">
    <CharacterJumpFromTheRight class="text-white !font-boing" :text="positionText" :textSizeClass="positionSizeClass" :textOutlineSizeClass="positionSizeClass" @timeline="timelinePosition = $event" />
  </div>

  <div v-else class="flex items-center justify-center size-full text-white">
    <div class="flex flex-col items-center">
      <CharacterJumpFromTheRight class="!font-boing" :text="fallbackProgramTitle" textSizeClass="text-[12em]" textOutlineSizeClass="text-[12.6em]" @timeline="timelinePosition = $event" />
    </div>
  </div>
</template>

<style scoped>
.position-container {
  container-type: size;
}

.position-container :deep(.text-transparent) {
  width: auto !important;
}
</style>
